import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/79ff226565aa061af9d610d2907aeb03.jpg"
          alt="Professional commercial facility services Houston TX"
          className="w-full h-full object-cover object-center"
        />
        {/* Multi-layer dark overlay for depth */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#03143A]/95 via-[#03143A]/80 to-[#03143A]/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#03143A]/60 via-transparent to-[#03143A]/30" />
      </div>

      {/* Decorative accent line */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-[#C70532] to-transparent opacity-60" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-36 pb-24 w-full">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2.5 px-5 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-8 animate-fade-in">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-fill text-[#C70532] text-xs" />
            </div>
            <span className="text-white/90 text-sm font-medium">Houston&apos;s Premier Facility Services Partner — Est. 2008</span>
          </div>

          {/* H1 */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white mb-7 leading-[1.06] animate-fade-in-up" style={{ animationDelay: '0.1s', animationFillMode: 'both' }}>
            Commercial Cleaning &amp;{' '}
            <span className="relative">
              <span className="text-[#C70532]">Facility Services</span>
            </span>{' '}
            That Elevate Your Business
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-white/75 mb-10 max-w-2xl leading-relaxed animate-fade-in-up font-light" style={{ animationDelay: '0.2s', animationFillMode: 'both' }}>
            Reliable, detail-driven janitorial and facility solutions designed to keep your property <strong className="text-white font-semibold">spotless, compliant, and client-ready.</strong>
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up" style={{ animationDelay: '0.3s', animationFillMode: 'both' }}>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-9 py-4.5 bg-[#C70532] hover:bg-[#a80428] text-white font-bold text-base rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              Get a Free Quote Today
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
            <a
              href="tel:+17133382553"
              className="inline-flex items-center justify-center gap-3 px-9 py-4.5 bg-white/10 backdrop-blur-md hover:bg-white/20 text-white font-bold text-base rounded-full border-2 border-white/25 hover:border-white/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-[#C70532]" />
              </div>
              Call Now: (713) 338-2553
            </a>
          </div>

          {/* Social proof badges */}
          <div className="flex flex-wrap items-center gap-6 mt-12 animate-fade-in" style={{ animationDelay: '0.5s', animationFillMode: 'both' }}>
            <div className="flex items-center gap-2 px-4 py-2.5 bg-white/8 backdrop-blur-sm rounded-xl border border-white/15">
              <div className="flex items-center gap-0.5">
                {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-amber-400 text-xs" />)}
              </div>
              <span className="text-white font-bold text-sm">4.8</span>
              <span className="text-white/55 text-xs">Google Rating</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2.5 bg-white/8 backdrop-blur-sm rounded-xl border border-white/15">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-[#C70532] text-sm" />
              </div>
              <span className="text-white text-sm font-semibold">Licensed &amp; Insured</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2.5 bg-white/8 backdrop-blur-sm rounded-xl border border-white/15">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-time-line text-[#C70532] text-sm" />
              </div>
              <span className="text-white text-sm font-semibold">15+ Years Experience</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2.5 bg-white/8 backdrop-blur-sm rounded-xl border border-white/15">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-group-line text-[#C70532] text-sm" />
              </div>
              <span className="text-white text-sm font-semibold">500+ Active Clients</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-fade-in" style={{ animationDelay: '1s', animationFillMode: 'both' }}>
        <span className="text-white/40 text-xs uppercase tracking-widest font-semibold">Scroll to explore</span>
        <div className="w-5 h-8 border border-white/20 rounded-full p-1 flex justify-center">
          <div className="w-1 h-2 bg-[#C70532] rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}
